<div class="rn-page">
  <div class="help-text-container">
    @if (!currentClient.feed_enabled) {
      <p>
        Since Two Way Messaging is an asynchronous conversation, your agent may
        need to ping the customer they are conversing with to let the customer
        know that there is a message waiting for them. This
        {{ newFeed.enabled ? 'Notification' : 'SMS' }} Ping will include a link
        directly back into the conversation.
      </p>
    }
    @if (currentClient.feed_enabled) {
      <p>
        Since Relay Messenger is an asynchronous conversation, your agent may
        need to ping the customer they are conversing with to let the customer
        know that there is a message waiting for them. This notification ping
        will include a link directly back into the conversation.
      </p>
    }
  </div>
  <rn-setup-banner-autoresponse
    [clientId]="clientId"
  ></rn-setup-banner-autoresponse>

  <div class="rn-page__section">
    @if (isLoading()) {
      <div class="rn-page--busy">
        <app-spinner
          [styleRules]="{ transform: 'translateY(250px)' }"
        ></app-spinner>
      </div>
    } @else {
      @if (smsPingForm) {
        <form class="form-group" [formGroup]="smsPingForm">
          <h3>{{ newFeed.enabled ? 'Notification' : 'SMS' }} Ping</h3>
          <div class="input-group input-group-with-preview clearfix">
            <div class="phone-container">
              <rn-generic-phone>
                <bubble [text]="isErrorPingMessages ? '' : fullSmsText"></bubble>
              </rn-generic-phone>
            </div>
            <div class="input-group-with-preview__fields fields-group">
              @if (isTranslationsEnabled && isRMPingTranslationsEnabled) {
                <div class="select-container">
                  <label for="language-select">Select the language you wish to configure</label>
                  <div class="language-select-row">
                    <mat-form-field appearance="outline" class="language-select-field">
                      <mat-select #languageSelect panelClass="language-select-panel" id="language-select"
                        [value]="languageCode" [disabled]="isErrorSupportedLanguages || !supportedLanguages.length"
                        (selectionChange)="onLanguageChange($event.value)">
                        @for (language of supportedLanguages; track language.code) {
                          <mat-option [value]="language.code" [attr.data-testid]="'language-select-option-' + language.code">
                            {{ language.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (isErrorSupportedLanguages) {
                      <p class="supported-languages-error">
                        Ops, could not load supported languages.
                      </p>
                    }
                  </div>
                  @if (isErrorPingMessages) {
                    <p class="supported-languages-error">
                      Ops, there was an error loading this language's ping messages.
                    </p>
                  }
                </div>
                <div class="spacer"></div>
              }
              @if (twoWayConfig.sms && (!isRMPingTranslationsEnabled || pingSmsModel)) {
                <rn-sms-builder
                  [isTwoWaySms]="true"
                  [smsModel]="currentSmsModel"
                  [smsFormGroup]="smsPingForm"
                  [bodyPlaceholder]="getPingMessagePlaceholder('body')"
                  [disclaimerPlaceholder]="getPingMessagePlaceholder('disclaimer')"
                  [alternateTextPlaceholder]="getPingMessagePlaceholder('alternate_text')"
                  [showDestination]="!isRMPingTranslationsEnabled"
                  [isNotificationPing]="true"
                ></rn-sms-builder>
              }
              <p>{{ blackoutWindowMessage }}</p>
            </div>
          </div>
        </form>
      }
    }

  </div>

  <div class="button-container">
    @if (isRMPingTranslationsEnabled) {
    <button class="btn btn-primary" id="save-btn" (click)="saveWithoutNavigation()"
      [disabled]="isLoading()">
      <span i18n="Label for Save button on multilingual configuration" id="save-button">
        Save
      </span>
    </button>
    } @else {
    <button class="btn btn-primary" id="next-btn" (click)="saveAndContinue()"
      [disabled]="!isLoading() && !this.smsPingForm.valid">
      <span i18n="Label for Next button on new client configuration" id="save-and-next-button">
        Save and Next
      </span>
      <span class="icon icon-right">
        <i class="fa fa-arrow-right"></i>
      </span>
    </button>
    }
  </div>
</div>

<message-dialog #smsPingMessage [showCancel]="false"></message-dialog>

<message-dialog
  #dynamicInputsMessage
  [showCancel]="true"
  (affirm)="onDynamicInputsAffirm()"
  >
  <p>
    You are about to save a
    {{ newFeed.enabled ? 'notification' : 'message' }} that has dynamic inputs
    without setting up
    {{
    newFeed.enabled ? 'alternate notification text' : 'an alternate message'
    }}. We recommend setting up
    {{
    newFeed.enabled ? 'alternate notification text' : 'an alternate message'
    }}
    in case this information is not provided for a user's account. If you
    attempt to launch the experience as is and the information requested is not
    available for a customer, this
    {{ newFeed.enabled ? 'notification' : 'message' }} will not be sent to that
    particular user.
  </p>
</message-dialog>

<unsaved-changes-dialog #unsavedChangesDialog [confirmDisabled]="!!smsPingForm && !smsPingForm.valid"
  (confirm)="onUnsavedChangesSave()" (cancel)="onUnsavedChangesDiscard()"
  (dismiss)="onUnsavedChangesDismiss()"></unsaved-changes-dialog>
